import Component from './PromotionBanner'

export default Component
